<template>
  <div class="date-range-picker-filter tw-max-w-full">
    <WdsInputDate
      v-model="rangeAdapter"
      :title
      :placeholder-start="$t('from')"
      :placeholder-end="$t('to')"
      can-deselect
      format="yyyy-mm-dd"
      :language
    />
  </div>
</template>

<script setup lang="ts">
import { WdsInputDate } from '@worksome/wds-components'
import { useVModel } from '@vueuse/core'
import { computed, Ref } from 'vue'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { $t } from '@/composables/translation'
import { fieldToReadAble } from '@/components/GraphqlDataTable/tools'

// Date formatted as Y-m-d (2019-12-31)
interface DateRangeInput {
  from: string | null
  to: string | null
}

const language = computed(() => currentUser.locale ?? currentLanguageSelected)

const emit = defineEmits<{
  'update:modelValue': [range: DateRangeInput]
}>()

const props = withDefaults(
  defineProps<{ meta: FilterMetaDataProp; modelValue: DateRangeInput }>(),
  {
    modelValue: () => ({
      from: null,
      to: null,
    }),
  },
)

const dateRange: Ref<DateRangeInput> = useVModel(props, 'modelValue', emit, {
  deep: true,
  passive: true,
})

const rangeAdapter = computed({
  get() {
    return {
      start: dateRange.value.from,
      end: dateRange.value.to,
    }
  },
  set({ start, end }) {
    dateRange.value.from = start
    dateRange.value.to = end
  },
})

const title = computed(() => {
  if (props.meta.filter.quickFilter) return ''
  switch (props.meta.filter.name) {
    case 'requestedDateRange':
      return $t('Submission date range')
    default:
      return $t(fieldToReadAble(props.meta.filter.name))
  }
})
</script>

<style lang="scss" scoped></style>
